module.exports = __webpack_public_path__ + "static/media/dgs3.png.594b3502.jpg";